<template>
    <div id="gallery" v-if="gallery">
        <div class="row">
            <el-card class="col-6 col-xl-3" shadow="hover" style="text-align: center;position: relative;"
                v-for="(item, index) in gallery" :body-style="{ padding: '0px' }">
                <!-- <img :src="require('img/' + item)" style="width: 100%" loading="lazy" /> -->
                <el-image style="width: 100%" :src="item" :preview-src-list="gallery" show-progress
                    :initial-index="index" fit="cover">
                    <template #error>
                        <div style="width: 100%; height: 100%; background:#f5f5f5; display: grid; place-items: center;">
                            <el-button type="primary" size="small" icon="el-icon-refresh"
                                @click="reloadSingleImage(item, index)" />
                        </div>
                    </template>
                </el-image>
                <i class="fa-solid fa-heart" style="font-size:1.5rem;color:#FF698C;position:absolute;right:
                                    1rem;top:1rem" v-show="item.includes('-h')" />
            </el-card>
        </div>
        <!-- <Waterfall :list="gallery" :breakpoints="breakpoints" :gutter="0">
            <template #item="{ item, index }">
                <el-card shadow="hover" style="text-align: center;" :body-style="{ padding: '0px' }">
                    <el-image style=" width: 100%" :src="item" @click="handleClick(index)" />
                </el-card>
            </template>
</Waterfall> -->
        <el-image-viewer v-if="showPreview" :url-list="gallery" show-progress :initial-index="showIndex"
            @close="showPreview = false" />
    </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { Waterfall, LazyImg } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { useCache } from '../utils/usecache'

let route = useRoute()
const title = route.params.name[0]
const gallery = ref()

const showPreview = ref(false)
const showIndex = ref(0)
const suffixes = ['.jpg', '.jpeg', '.png', '.gif']

const breakpoints = {
    10000: {
        rowPerView: 4,
    },
    700: {
        rowPerView: 2,
    }
}

// const getData = (name) => {
//     let g = Object.values(require.context('img', true, /^.\/gallery_/).keys())
//     let ga = []
//     let ga_t = []
//     for (let j of g) {
//         if (j.includes(name) && !j.includes('-g')) {
//             let q = j.replace(/^.\//, '')
//             ga.push(require(`img/${q}`))
//             ga_t.push(require(`img/thumbnail/${q}`))
//         }
//     }
//     gallery.value = [ga.reverse(), ga_t.reverse()]
// }

const getData = async (name) => {
    try {
        const res = await useCache('galleryList', () => {
            return axios.get('/gallery/').then(res => res.data)
        })
        if (res && Array.isArray(res)) {
            gallery.value = res.filter(item => {
                if (item.type !== 'file') return false
                const suffix = item.name.slice(item.name.lastIndexOf('.')).toLowerCase()
                return suffixes.includes(suffix) && item.name.includes(name)
            }).map(item => {
                return 'http://img.helloworldend.top/gallery/' + item.name
            }).reverse()
        }
    } catch (error) {
        console.error('获取图片列表失败：', error)
    }
}

const reloadSingleImage = (item, index) => {
    gallery.value[index] = item + (item.includes('?') ? '&' : '?') + '_t=' + Date.now()
}


const handleClick = (index) => {
    showPreview.value = true
    showIndex.value = index
}

onMounted(() => {
    getData(title);
})

</script>